import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "modal PhoneVerificationModal" }
const _hoisted_2 = { class: "modal--content" }
const _hoisted_3 = { class: "modal--content-body" }
const _hoisted_4 = { class: "HeadingtextinfoDv" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 0,
  class: "verificationLoader"
}
const _hoisted_7 = { class: "inputWithLabelDv" }
const _hoisted_8 = { class: "btninfoDv" }
const _hoisted_9 = {
  key: 0,
  class: "btn btn--primary"
}
const _hoisted_10 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_otp_input = _resolveComponent("v-otp-input")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[7] || (_cache[7] = _createElementVNode("div", {
      id: "recaptcha-wrapper",
      style: {"display":"none"}
    }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "modal--backdrop" }, null, -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.$t("setting.verification.title", {
                type: _ctx.twoFaPhoneVerifictaion
                  ? _ctx.$t("setting.common.phoneNumber")
                  : _ctx.$t("setting.twoFactorAuth.title"),
              })), 1),
            (_ctx.phone && !_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.$t("setting.verification.subTitlePhone", {
                phone: _ctx.phone,
              })), 1))
              : _createCommentVNode("", true)
          ]),
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[4] || (_cache[4] = [
                _createElementVNode("div", { class: "loader" }, null, -1)
              ])))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_v_otp_input, {
                    "is-disabled": _ctx.isTimeoutLessThanOne,
                    ref: "otpInput",
                    class: "otpContainer leftinfoPhoneDv",
                    value: _ctx.bindModal,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.bindModal) = $event)),
                    "input-classes": "otp-input",
                    separator: "",
                    "num-inputs": 6,
                    "should-auto-focus": true,
                    "input-type": "letter-numeric",
                    conditionalClass: ['one', 'two', 'three', 'four'],
                    placeholder: [],
                    onOnComplete: _ctx.handleOnComplete
                  }, null, 8, ["is-disabled", "value", "onOnComplete"])
                ]),
                (_ctx.timeout != -1)
                  ? (_openBlock(), _createBlock(_component_el_row, {
                      key: 0,
                      class: "code-resend"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _createElementVNode("p", null, [
                              _createTextVNode(_toDisplayString(_ctx.$t("setting.verification.codeExpire")) + " ", 1),
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("setting.verification.seconds", { count: _ctx.timeout })), 1)
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              class: _normalizeClass({ disabled: _ctx.timeout > 0 }),
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sendCode()))
                            }, _toDisplayString(_ctx.$t("setting.verification.resendCode")), 3)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_8, [
                  (_ctx.isLoading)
                    ? (_openBlock(), _createElementBlock("button", _hoisted_9, _cache[5] || (_cache[5] = [
                        _createElementVNode("div", { class: "loader" }, null, -1)
                      ])))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "btn btn--primary",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.verifyCode()))
                      }, _toDisplayString(_ctx.$t("setting.common.verify")), 1)),
                  _createElementVNode("button", {
                    class: "btn btn--outline",
                    disabled: _ctx.isLoading,
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.dismiss()))
                  }, _toDisplayString(_ctx.$t("common.actions.cancel")), 9, _hoisted_10)
                ])
              ], 64))
        ])
      ])
    ])
  ], 64))
}